<template>
  <div>
    <collapse :active-index="0">
      <collapse-item>
        <h3 slot="title" class="mb-0">Información del Productor</h3>

        <div>
          <div class="row">
            <div class="col-sm-6 col-xs-12">
              <p class="h5 mb-0">Razón Social</p>
              <p>{{ producer.businessName }}</p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Distribuidor</p>
              <router-link
                v-if="$can('show', 'distributors')"
                :to="{ name: 'DistributorShow', params: { id: producer.distributorId } }"
                class="like btn-link"
              >
                {{ producer.distributor.name }}
              </router-link>
              <span v-else>{{ producer.distributor.name }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">CUIT</p>
              <p v-if="producer.cuit">{{ producer.cuit }}</p>
              <p v-else>-</p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Email</p>
              <p>{{ producer.email }}</p>
            </div>
          </div>

          <div class="row">
            <div v-if="producer.city" class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Ubicación</p>
              <p>
                <span>{{ producer.city.name }}, {{ producer.city.province.name }}</span> <br />
                <small class="font-weight-bold">{{ producer.address }}</small>
              </p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Telefono</p>
              <p>{{ producer.phone }}</p>
            </div>
          </div>

          <div v-if="hasCropsData || hasHectaresData" class="row">
            <div class="col-sm-12">
              <h4 class="h4 mt-3 mb-3">Datos de siembra</h4>
            </div>
          </div>

          <div v-if="hasHectaresData" class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Hectáreas propias</p>
              <p v-if="producer.ownedHectares">{{ producer.ownedHectares }}</p>
              <p v-else>-</p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Hectáreas arrendadas</p>
              <p v-if="producer.leasedHectares">{{ producer.leasedHectares }}</p>
              <p v-else>-</p>
            </div>
          </div>

          <div v-if="hasCropsData" class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Maíz</p>
              <p v-if="producer.corn">{{ producer.corn }}&nbsp;<small>[HAS]</small></p>
              <p v-else>-</p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Maíz silero</p>
              <p v-if="producer.storageCorn">{{ producer.storageCorn }}&nbsp;<small>[HAS]</small></p>
              <p v-else>-</p>
            </div>

            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <p class="h5 mb-0">Alfalfa</p>
              <p v-if="producer.alfalfa">{{ producer.alfalfa }}&nbsp;<small>[HAS]</small></p>
              <p v-else>-</p>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6 col-xs-12 text-center text-sm-left">
              <badge class="m-1" type="danger">
                <span class="mr-1">{{ producer.visitsCount }}</span>
                <span v-if="producer.visitsCount === 1">Visita</span>
                <span v-else>Visitas</span>
              </badge>

              <badge class="m-1" type="primary">
                <span class="mr-1">{{ producer.plotsCount }}</span>
                <span v-if="producer.plotsCount === 1">Lote</span>
                <span v-else>Lotes</span>
              </badge>

              <badge class="m-1" type="success">
                <span class="mr-1">{{ hectares }}</span>
                <span v-if="hectares === 1">Hectárea</span>
                <span v-else>Hectáreas</span>
              </badge>

              <badge class="mr-1" type="default">
                <span class="mr-1">{{ producer.documentsCount }}</span>
                <span v-if="producer.documentsCount === 1">Archivo</span>
                <span v-else>Archivos</span>
              </badge>
            </div>
          </div>
        </div>
      </collapse-item>
    </collapse>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  name: 'ProducerData',
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    producer: null,
    hectares: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    hasHectaresData() {
      return this.producer.ownedHectares || this.producer.leasedHectares;
    },

    hasCropsData() {
      return this.producer.ownedHectares || this.producer.leasedHectares;
    },
  },
};
</script>
